var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.48 14.9404L14.9033 12.3638",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8984 8.13481C16.0644 9.30089 16.0644 11.1927 14.8984 12.3588C13.7323 13.5249 11.8404 13.5249 10.6744 12.3588C9.50828 11.1927 9.50828 9.30089 10.6744 8.13481C11.8417 6.96873 13.7323 6.96873 14.8984 8.13481",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15967 17.4955H12.9997",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1458 4.23448C25.6447 8.73332 25.6447 16.0274 21.1458 20.5262C16.647 25.025 9.35293 25.025 4.85411 20.5262C0.35527 16.0274 0.35527 8.7333 4.85411 4.23448C9.35295 -0.264359 16.647 -0.264359 21.1458 4.23448",
    stroke: "#001965",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/noResult.64442263b8e0ff631b6ddfc7a22ca6c6.svg";
export { ForwardRef as ReactComponent };